import { buildModelManager } from "../builder.js";
const DefaultAttendanceTestLinkSelection = {
  __typename: true,
  id: true,
  assignedUserEmail: true,
  assignedUserId: true,
  assignedUserName: true,
  createdAt: true,
  createdById: true,
  disabledAt: true,
  enabled: true,
  expiresAt: true,
  institution: true,
  label: true,
  lastUsedAt: true,
  notificationRecipients: true,
  token: true,
  updatedAt: true
};
const modelApiIdentifier = "attendanceTestLink";
const pluralModelApiIdentifier = "attendanceTestLinks";
;
;
;
;
;
const operations = [
  {
    type: "findOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultAttendanceTestLinkSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultAttendanceTestLinkSelection,
    namespace: null
  },
  {
    type: "findMany",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultAttendanceTestLinkSelection,
    namespace: null
  },
  {
    type: "findFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultAttendanceTestLinkSelection,
    namespace: null
  },
  {
    type: "maybeFindFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultAttendanceTestLinkSelection,
    namespace: null
  },
  {
    type: "findOne",
    operationName: pluralModelApiIdentifier,
    functionName: "findById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultAttendanceTestLinkSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: pluralModelApiIdentifier,
    functionName: "maybeFindById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultAttendanceTestLinkSelection,
    namespace: null
  },
  {
    type: "findOne",
    operationName: pluralModelApiIdentifier,
    functionName: "findByToken",
    findByField: "token",
    findByVariableName: "token",
    modelApiIdentifier,
    defaultSelection: DefaultAttendanceTestLinkSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: pluralModelApiIdentifier,
    functionName: "maybeFindByToken",
    findByField: "token",
    findByVariableName: "token",
    modelApiIdentifier,
    defaultSelection: DefaultAttendanceTestLinkSelection,
    namespace: null
  },
  {
    type: "computedView",
    operationName: "view",
    functionName: "view",
    gqlFieldName: "attendanceTestLinkGellyView",
    namespace: null,
    variables: {
      query: { type: "String", required: true },
      args: { type: "JSONObject" }
    }
  }
];
const AttendanceTestLinkManager = buildModelManager(
  modelApiIdentifier,
  pluralModelApiIdentifier,
  DefaultAttendanceTestLinkSelection,
  operations
);
export {
  AttendanceTestLinkManager,
  DefaultAttendanceTestLinkSelection
};
//# sourceMappingURL=AttendanceTestLink.js.map
